module.exports = __webpack_public_path__ + "img/mealreminder-user-small.87fca8a2.png";